import { RESET_PASSWORD_EMAIL, RESET_PASSWORD_PHONE } from "../gql/AuthQueries";

import {
  required,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";

export default {
  name: "reset_password",

  data() {
    return {
      email: "",
      password: "",
      repeatPassword: "",
      submitLoading: false,
      statusResetPassword: "init",
      errorTitle: ""
    };
  },

  validations() {
    let params = {
      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(16)
      },

      repeatPassword: {
        sameAsPassword: sameAs("password")
      }
    };

    return params;
  },

  mounted: function() {
    if (
      !this.$route.query.reset_password_token &&
      !this.$route.params.reset_password_pin
    ) {
      this.$router.push({ name: "home" });
    } else {
      this.email = this.$route.query.email;
    }
  },

  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitLoading = true;

        if (this.$route.params.reset_password_pin) {
          this.resetByPhone();
        } else {
          this.resetByEmail();
        }
      }
    },

    resetByEmail() {
      this.$apollo
        .mutate({
          mutation: RESET_PASSWORD_EMAIL,
          variables: {
            resetPasswordToken: this.$route.query.reset_password_token,
            password: this.password,
            passwordConfirmation: this.repeatPassword
          }
        })
        .then(({ data: { resetPasswordByToken: { user, accessToken } } }) => {
          this.initUser(user, accessToken);

          this.statusResetPassword = "success";
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
            this.errorTitle = errors[error].message;
          }

          this.statusResetPassword = "error";
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },

    resetByPhone() {
      this.$apollo
        .mutate({
          mutation: RESET_PASSWORD_PHONE,
          variables: {
            resetPasswordPin: this.$route.params.reset_password_pin,
            phone: localStorage.getItem("signupPhone"),
            password: this.password,
            passwordConfirmation: this.repeatPassword
          }
        })
        .then(({ data: { resetPasswordByPin: { user, accessToken } } }) => {
          this.initUser(user, accessToken);

          this.$toasted.success("Your password has been successfully reset!");

          this.$router.push({ name: "home" });
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
            this.errorTitle = errors[error].message;
          }

          this.statusResetPassword = "error";
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },

    initUser(user, token) {
      if (typeof localStorage !== "undefined" && token) {
        localStorage.setItem("AUTH_TOKEN", token);
        localStorage.removeItem("signupPhone");
      }

      this.$store.dispatch("initUser", user);
    }
  },

  components: {}
};
